import { FileType, FileUpload } from "./types";
import React, { useCallback, useState } from "react";
import { FileDropArea } from "./FileDropArea";
import { FileTypeForm } from "./FileTypeForm";
import clsx from "clsx";
import styles from "./Upload.module.scss";
import { QQSection } from "common/components";

interface UploadProps {
  uploadFile: File | null;
  fileType: FileType | null;
  onSubmit?: (fileUpload: FileUpload) => void;
  onAreaChange?: (area: "excel" | "intelligent" | null) => void;
}

export const Upload: React.FC<UploadProps> = ({
  uploadFile,
  fileType,
  onSubmit = () => {},
  onAreaChange = () => {},
}) => {
  const [file, setFile] = useState<File | null>(uploadFile);
  const [selectedArea, setSelectedArea] = useState<"excel" | "intelligent" | null>(null);

  const handleOnSubmit = (fileType: FileType) => {
    if (file) {
      onSubmit({ file, fileType, area: selectedArea });
    }
  };

  const handleFileSelected = useCallback(
    (selectedFile: File, area: "excel" | "intelligent") => {
      setFile(selectedFile);
      setSelectedArea(area);
      onAreaChange(area);
    },
    [onAreaChange],
  );

  const handleRemoveFile = useCallback(() => {
    setFile(null);
    setSelectedArea(null);
    onAreaChange(null);
  }, [onAreaChange]);

  return (
    <QQSection bottomSection>
      <div
        className={clsx(styles.uploadArea, styles.spacedContainer, "mx-auto d-flex flex-column")}
      >
        <FileDropArea
          onFileSelected={handleFileSelected}
          selectedFile={file}
          selectedArea={selectedArea}
          onRemoveFile={handleRemoveFile}
        />
      </div>
      {file && (
        <QQSection bottomSection>
          <FileTypeForm type={fileType} onSubmit={handleOnSubmit} />
        </QQSection>
      )}
    </QQSection>
  );
};
